import {
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from '@headlessui/react'
import { type Suggestion } from 'lib/suggestions'

export { Combobox as LinkCombobox } from '@headlessui/react'

import { isInternalLink } from 'app/_components/Editor/extensions/withLinks/Link'
import { PopoverClose } from 'app/_components/Popover'
import { isEmail, isUrl } from '.'

type InputProps = {
  onChange: (query: string) => void
}

export function LinkComboboxInput({ onChange }: InputProps) {
  return (
    <ComboboxInput
      className="focus:border-focus w-full"
      name="url"
      autoComplete="off"
      placeholder="Link einfügen oder suchen"
      onChange={(e) => onChange(e.target.value)}
    />
  )
}

type OptionsProps = {
  isLoading: boolean
  query: string
  suggestions: Suggestion[]
}

export function LinkComboboxOptions({
  isLoading,
  query,
  suggestions,
}: OptionsProps) {
  if (isLoading)
    return (
      <span className="text-gray-40 mt-4 block text-sm">
        Lade Vorschläge...
      </span>
    )

  if (query && suggestions.length === 0 && !isUrl(query) && !isEmail(query))
    return (
      <p className="text-gray-40 mt-4 px-4 text-sm">
        Keine Vorschläge gefunden oder ungültige URL
      </p>
    )

  return (
    <ComboboxOptions static>
      {isUrl(query) ? (
        <LinkComboboxOption
          value={query}
          title={isInternalLink(query) ? 'Interner Link' : 'Externer Link'}
        >
          {query}
        </LinkComboboxOption>
      ) : isEmail(query) ? (
        <LinkComboboxOption value={query} title="E-Mail-Adresse">
          {query}
        </LinkComboboxOption>
      ) : (
        suggestions.map((suggestion) => (
          <LinkComboboxOption
            key={suggestion.id}
            value={suggestion}
            title={suggestion.subtitle}
          >
            {suggestion.title}
          </LinkComboboxOption>
        ))
      )}
    </ComboboxOptions>
  )
}

type OptionProps = {
  title?: string | null
  children: React.ReactNode
  value: string | Suggestion
}

function LinkComboboxOption({ children, value, title }: OptionProps) {
  return (
    <PopoverClose asChild>
      <ComboboxOption
        value={value}
        className="hover:bg-gray-20 focus-visible:bg-gray-20 data-[active]:bg-gray-20 data-[selected]:bg-gray-20 cursor-pointer px-4"
      >
        <span className="text-gray-40 text-sm">{title}</span>
        <span className="block w-full truncate text-left">{children}</span>
      </ComboboxOption>
    </PopoverClose>
  )
}
